import { StyleSheet } from 'aphrodite';
import { hexToRGBA } from '../../../../../models/UiUtils';
import {
	borderColor,
	brandPrimary,
	brandPrimaryText,
	darkGrayFontColor,
	destructive,
	grayIconFill,
	lightGray,
	success,
	successTint,
	white,
	midGray,
} from '../../../../../web/styles/colors';
import { DefaultBorder } from '../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	actionButton: {
		':not(:first-child)': {
			marginLeft: 20,
		},
	},
	checkboxText: {
		fontSize: 16,
		paddingLeft: 12,
		whiteSpace: 'nowrap',
	},
	container: {
		marginBottom: 50,
		marginTop: 30,
		minHeight: 400,
		position: 'relative',
	},
	errorBanner: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
		background: hexToRGBA(destructive, 0.1),
		padding: 14,
		border: `1px solid ${destructive}`,
		borderRadius: 8,
		marginTop: 12,
		marginBottom: 12,
	},
	errorText: {
		color: destructive,
	},
	errorWarning: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	modalActions: {
		marginTop: 32,
		display: 'flex',
		gap: 16,
	},
	modalContainer: {
		width: 400,
	},
	table: {
		borderCollapse: 'collapse',
		borderWidth: 0,
		width: '100%',
	},
	tableCell: {
		paddingTop: 16,
		paddingBottom: 16,
	},
	connectedUsersCell: {
		paddingTop: 16,
		paddingBottom: 16,
		maxWidth: 350,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	tableHead: {
		backgroundColor: white,
		color: grayIconFill,
		fontSize: 12,
		borderBottom: `1px solid ${borderColor}`,
	},
	headerCell: {
		background: white,
		fontWeight: 'normal',
		paddingBottom: 16,
	},
	actionsButton: {
		alignItems: 'center',
		display: 'flex',
		height: 28,
		justifyContent: 'center',
		width: 28,
		padding: 4,
	},
	actionsDropdownContent: {
		minWidth: 240,
		whiteSpace: 'nowrap',
	},
	avatar: {},
	actionsDropdown: {
		width: '100%',
	},
	menu: {
		background: white,
		border: DefaultBorder,
		boxShadow: '0 2px 4px 0 rgba(0, 0, 0, .1)',
		minWidth: 200,
	},
	menuItem: {
		':hover': {
			background: midGray,
		},
		cursor: 'pointer',
		fontSize: 14,
		fontWeight: 'normal',
		overflow: 'hidden',
		padding: '16px 20px',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	expander: {},
	tableRow: {
		width: '100%',
		minWidth: 300,
		borderBottom: `1px solid ${borderColor}`,
	},
	phoneNumber: {
		color: brandPrimaryText,
		fontSize: 18,
	},
	sharedNumber: {
		color: success,
		fontSize: 14,
		display: 'flex',
		gap: 8,
		marginTop: 8,
	},
	sharedNumberModalHeader: {
		color: success,
		fontSize: 14,
		display: 'flex',
		gap: 8,
		marginTop: 8,
	},
	phoneNumberCell: {
		paddingLeft: 20,
	},
	phoneNumberHeaderCell: {
		paddingLeft: 20,
	},
	unorderedList: {
		marginTop: 12,
	},
	lineItem: {
		display: 'flex',
		gap: 12,
		padding: 4,
		alignItems: 'center',
		minHeight: 40,
	},
	lineItemAlternate: {
		backgroundColor: lightGray,
	},
	trashButton: {
		marginLeft: 'auto',
		':disabled': {
			cursor: 'not-allowed',
			opacity: 0.5,
		},
		':disabled:hover': {
			opacity: 0.5,
		},
	},
	disabledButton: {
		opacity: 0.5,
		cursor: 'not-allowed',
		pointerEvents: 'none',
	},
	lineItemPendingRemoval: {
		opacity: 0.5,
	},
	lineItemPendingAddition: {
		backgroundColor: successTint,
	},
	userNameStrikethrough: {
		textDecoration: 'line-through',
	},
	userWarning: {
		color: destructive,
		marginLeft: 8,
		display: 'inline-flex',
		alignItems: 'center',
	},
	addUserContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		marginTop: 20,
	},
	addUserSearchField: {
		flex: 1,
	},
	addButton: {
		alignItems: 'center',
		border: `1px solid ${brandPrimary}`,
		borderRadius: 6,
		color: brandPrimary,
		cursor: 'pointer',
		display: 'flex',
		height: 40,
		justifyContent: 'center',
		width: 40,
		':hover': {
			opacity: 0.8,
		},
	},
	deactivateDialogContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
	},
	deactivateDialogText: {
		margin: 0,
	},
	deactivateDialogInfo: {
		margin: 0,
	},
	buttonSpinner: {
		marginRight: 8,
	},
	supportToolsSection: {
		marginBottom: 20,
		border: `1px solid ${borderColor}`,
		borderRadius: 6,
		backgroundColor: white,
	},
	supportToolsHeader: {
		alignItems: 'center',
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		fontWeight: 500,
		gap: 8,
		padding: 12,
		width: '100%',
		':hover': {
			backgroundColor: lightGray,
		},
	},
	supportToolsTitle: {
		color: grayIconFill,
	},
	chevron: {
		color: grayIconFill,
		flexShrink: 0,
	},
	supportToolsContent: {
		borderTop: `1px solid ${borderColor}`,
		padding: 16,
	},
	toolItem: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
	},
	toolDescription: {
		color: grayIconFill,
		fontSize: 14,
	},
	modalHeader: {
		color: brandPrimaryText,
		fontSize: 20,
		fontWeight: 600,
		marginBottom: 16,
	},
	modalDescription: {
		color: darkGrayFontColor,
		fontSize: 16,
		lineHeight: 1.5,
		marginBottom: 12,
	},
	modalWarning: {
		color: grayIconFill,
		fontSize: 14,
		lineHeight: 1.5,
		marginBottom: 24,
	},
});
